
import React from 'react';
import {Redirect, Route, Switch} from "react-router-dom";
import Mentor from "./Mentor";
import Mentee from "./Mentee";
import CreateProfileStart from "./CreateProfileStart";
import {useUser} from "../Components/UserProvider";
import StartHome from './StartHome';

export default function ProfileGuard({ children }) {
    const user = useUser();

    if (!user.mentor_profile && !user.mentee_profile) {
        return <StartHome>
            <Switch>
                <Route path="/start" component={CreateProfileStart} />
    
                <Route path="/register/mentor" component={Mentor} />
                <Route path="/register/mentee" component={Mentee} />
    
                <Redirect to="/start" />
            </Switch>
        </StartHome>;
    }

    return children;
}
